import React, { useState } from 'react'
import { Container } from './styles'
import emailIcon from '../../assets/email-icon.svg'
import phoneIcon from '../../assets/phone-icon.svg'
import { Form } from '../Form/Form'

// --- FUNGSI FALLBACK BARU (UNTUK HTTP) ---
/**
 * Salin ke clipboard menggunakan metode document.execCommand (fallback).
 */
const fallbackCopyToClipboard = (text: string) => {
  const textArea = document.createElement('textarea')
  textArea.value = text
  
  textArea.style.top = "0"
  textArea.style.left = "0"
  textArea.style.position = "fixed"

  document.body.appendChild(textArea)
  textArea.focus()
  textArea.select()

  try {
    document.execCommand('copy')
    return Promise.resolve(true)
  } catch (err) {
    console.error('Fallback: Gagal menyalin', err)
    return Promise.reject(err)
  } finally {
    document.body.removeChild(textArea)
  }
}

/**
 * Helper copy-to-clipboard yang aman, berfungsi di HTTPS dan HTTP.
 */
const copyToClipboard = (text: string) => {
  if (!navigator.clipboard) {
    return fallbackCopyToClipboard(text)
  }
  return navigator.clipboard.writeText(text)
}
// --- AKHIR FUNGSI BARU ---


export function Contact() {
  const [copied, setCopied] = useState(false)
  const email = 'igotdisease@gmail.com'

  // --- PERBARUI FUNGSI INI ---
  const copyEmailToClipboard = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault() // Mencegah link <a> berpindah halaman
    copyToClipboard(email).then(() => { // <-- Gunakan helper baru
      setCopied(true)
      setTimeout(() => setCopied(false), 2000)
    })
  }

  return (
    <Container id="contact">
      <header>
        <h2>Contact</h2>
        <p>Find a bug or have a project in mind?</p>
        <p>I'm open to collaborations. Feel free to reach out.</p>
      </header>
      <div className="contacts">
        
        {/* Kode <a> tag Anda sudah benar, tidak perlu diubah */}
        <div className="email-container" style={{ cursor: 'pointer' }}>
          <a href="#!" onClick={copyEmailToClipboard}>
            <img src={emailIcon} alt="Email" />
          </a>
          <a href="#!" onClick={copyEmailToClipboard}>
            {copied ? 'Copied!' : email}
          </a>
        </div>
        
        <div>
          <a href="tel:+6283129133900">
            <img src={phoneIcon} alt="Phone No" />
          </a>
          <a href="tel:+6283129133900">(+62) 831-2913-3900</a>
        </div>
      </div>
      <Form></Form>
    </Container>
  )
}